import { createStateSelectorHook } from 'src/lib/sweetState';

import { CustomerMemberStore } from './CustomerMemberStore';

export const useCustomerMembers = createStateSelectorHook(CustomerMemberStore, [
  'members',
  'loadingMembers',
  'processingUser',
  'currentCustomerId',
]);
